const { toBool, toInt, toNullableInt } = require('@/functions/transform');

/**
 * @param {number} [branchID]
 * @param {number} [productID]
 *
 * @constructor
 */
const StockLevel = function (branchID, productID) {
    /**
     * @type {number|null}
     */
    this.branchID = branchID || null;

    /**
     * @type {number|null}
     */
    this.productID = productID || null;

    /**
     * The current stock level for this product as returned by the API.
     *
     * @type {number|null}
     */
    this.availableQty = null;

    /**
     * Has the operator manually disabled stock validation for this product in this cart.
     *
     * @type {boolean}
     */
    this.disableStockValidation = false;
};

StockLevel.prototype = {
    getHydrationMap() {
        return {
            branchID: toInt,
            productID: toInt,
            availableQty: toNullableInt,
            disableStockValidation: toBool,
        };
    },
};

module.exports = StockLevel;
